import { render, staticRenderFns } from "./CreateEditForm.vue?vue&type=template&id=88b128da&scoped=true&lang=pug"
import script from "./CreateEditForm.vue?vue&type=script&lang=js"
export * from "./CreateEditForm.vue?vue&type=script&lang=js"
import style0 from "./CreateEditForm.vue?vue&type=style&index=0&id=88b128da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b128da",
  null
  
)

export default component.exports